<template>
  <!-- Barra de contato fixa no rodapé inferior.
       Referência: contabilizei.com.br (contato sempre visível), com o
       direcionamento ao comercial do pushing.com.br.
       É o ponto de entrada persistente; o formulário continua na seção. -->
  <div class="barra-contato" :class="{ 'barra-contato--oculta': oculta }">
    <div class="barra-contato__inner">
      <div class="barra-contato__texto">
        <strong>Quer ser cliente Creditall?</strong>
        <span class="d-none d-md-inline">
          Fale com nosso time comercial e receba uma proposta.
        </span>
      </div>

      <div class="barra-contato__acoes">
        <a
          :href="telHref"
          class="barra-contato__tel"
          @click="onLigar"
        >
          <i class="bi bi-telephone-fill"></i>
          <span class="d-none d-sm-inline">{{ telefoneDisplay }}</span>
          <span class="d-sm-none">Ligar</span>
        </a>

        <a href="#comercial" class="barra-contato__cta" @click="onCta">
          Fale com o Comercial
        </a>
      </div>

      <button
        type="button"
        class="barra-contato__fechar"
        aria-label="Ocultar barra de contato"
        @click="fechar"
      >
        &times;
      </button>
    </div>
  </div>
</template>

<script>
import { TELEFONE_DISPLAY, telUrl } from '../services/contato';
import { analytics } from '../services/analyticsService';

export default {
  name: 'BarraContatoFixa',
  data() {
    return { oculta: false };
  },
  mounted() {
    document.body.classList.add('tem-barra-contato');
  },
  beforeUnmount() {
    document.body.classList.remove('tem-barra-contato');
  },
  computed: {
    telHref() {
      return telUrl;
    },
    telefoneDisplay() {
      return TELEFONE_DISPLAY;
    },
  },
  methods: {
    fechar() {
      this.oculta = true;
      document.body.classList.remove('tem-barra-contato');
    },
    onLigar() {
      analytics.supportClick('barra_fixa');
    },
    onCta() {
      analytics.ctaComercialClick('barra_fixa');
    },
  },
};
</script>

<style scoped>
.barra-contato {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998; /* abaixo do widget de atendimento (9999) */
  background: #bf1b39;
  color: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease;
}
.barra-contato--oculta {
  transform: translateY(100%);
}

.barra-contato__inner {
  max-width: 1140px;
  margin: 0 auto;
  padding: 10px 16px;
  /* espaço à direita para não passar por baixo do balão de atendimento */
  padding-right: 96px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.barra-contato__texto {
  font-size: 14px;
  line-height: 1.3;
}
.barra-contato__texto strong {
  display: block;
  font-size: 15px;
}
.barra-contato__texto span {
  opacity: 0.9;
}

.barra-contato__acoes {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.barra-contato__tel {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.barra-contato__tel:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}

.barra-contato__cta {
  background: #fff;
  color: #bf1b39;
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  text-decoration: none;
  padding: 9px 18px;
  border-radius: 6px;
}
.barra-contato__cta:hover {
  color: #8c0c23;
  background: #f3f3f3;
}

.barra-contato__fechar {
  position: absolute;
  top: 4px;
  right: 8px;
  background: transparent;
  border: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 2px 6px;
}
.barra-contato__fechar:hover {
  color: #fff;
}

@media (max-width: 767px) {
  .barra-contato__inner {
    padding: 8px 12px;
    padding-right: 76px;
    gap: 10px;
  }
  .barra-contato__texto strong {
    font-size: 13px;
  }
  .barra-contato__cta,
  .barra-contato__tel {
    font-size: 13px;
    padding: 8px 12px;
  }
}
</style>

<style>
/* Não-scoped de propósito: a barra é fixa, então o conteúdo do rodapé
   precisa de respiro para não ficar escondido embaixo dela. */
body.tem-barra-contato {
  padding-bottom: 64px;
}
@media (max-width: 767px) {
  body.tem-barra-contato {
    padding-bottom: 60px;
  }
}
</style>
